<template>
  <div>

    <template v-if="propertyObject && !isEmpty">

      <div class="container">

        <div class="property" v-if="propertyObject.servus">
          <span class="key"><lang :labelKey="'PIM-PRODUCT-'+property.toUpperCase() + '-SERVUS'"></lang>:</span><br>
          <span class="value" v-html="propertyObject.servus"></span>
        </div>

        <div class="property" v-if="propertyObject.sisix">
          <span class="key"><lang :labelKey="'PIM-PRODUCT-'+property.toUpperCase() + '-SISIX'"></lang>:</span><br>
          <span class="value" v-html="propertyObject.sisix"></span>
        </div>
      </div>

    </template>

</div>

</template>

<script>
export default {
  name: "pimProductDetailField",

  components: {

  },

  props: {
    product: {
      type: Object,
      default: {},
      required: true
    },
    property: {
      type: String,
      required: true
    },

  },

  data() {
    return {

    }
  },

  created() {

  },

  mounted() {},

  computed: {
    propertyObject() {
      return this.product[this.property];
    },
    isEmpty() {
      return !( (this.propertyObject.servus && this.propertyObject.servus != '') || (this.propertyObject.sisix && this.propertyObject.sisix != '') );
    }

  }

};
</script>

<style lang="scss">

.container {
  margin-left: 10px !important;
  margin: 0 0 20px 0;
  display: block;
  border: none;

  .property{
    background: #f0f1f2;
    padding: 10px;
    border-radius: 3px;
    /*padding: 2px 5px;*/
    /*width: 440px;*/
    white-space: normal;
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    .key {
      display: inline-block;
      font-weight: 500;
      overflow: hidden;
      font-size: 11px;
      text-transform: uppercase;
    }
    .value {
      font-size: 11px !important;
      width: 440px;
      p {
        padding-bottom: 10px;
      }
    }
  }
}

</style>
